<template>
  <div :class="align == 'center' ? 'text-center' : ''">
    <h4 v-if="header">{{ header }}</h4>
    <p v-if="secondBody" style="color: var(--primary-color)">
      {{ secondBody }}
    </p>
    <p v-html="body"></p>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
export default {
  name: 'MainHeadline',
  props: {
    header: String,
    body: String,
    secondBody: String,
    align: String
  }
};
</script>

<style lang="sass" scoped>
h4
 color: $primary;
p
  font-size: 14px;
  line-height: 21px;
</style>
